import type { SVGProps } from "react";

export const ShareVideo = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.903 4.376H9.77c-2.437 0-4.419 2.064-4.419 4.6v1.776h1.2V8.976c0-1.875 1.444-3.4 3.219-3.4h3.133l-2.328 2.328.848.848L15.2 4.976 11.423 1.2l-.848.848z"
      />
      <path
        fill="currentColor"
        d="M1.2 8.995c0-5.19.429-6.342 4.152-6.556v1.184C2.465 3.757 2.4 4.535 2.4 8.995c0 2.785.025 4.134.747 4.787.559.477 1.535.585 3.241.61q.425.004.912.003v.004h.5c4.946 0 5.364-.08 5.397-4h1.196c-.08 4.694-.952 5.2-6.593 5.2q-.459 0-.876-.005c-2.41-.014-3.816-.178-4.631-.938C1.359 13.83 1.2 12.3 1.2 9.499h.002z"
      />
    </svg>
  );
};
